import { LocationNumbersService } from "../../../services";

const fetchA2PRestriction = async function ({ commit, dispatch, state }, config) {
    const { locationId } = config

    // check if value is set in state)
    if (state.isA2PRestrictedByCompany === false || state.isA2PRestrictedByCompany === true) { // avoids null
        return state.isA2PRestrictedByCompany;
    }

    try {
        const data = await LocationNumbersService.fetchA2PRestriction(locationId);
        commit('setA2PRestrictionByCompany', data?.isRestricted);
        return data;
    } catch (error) {
        throw error;
    }
};

export default fetchA2PRestriction;